import { useEffect } from 'react';
import { gitlabAuthApiRef, useApiHolder } from '@backstage/core-plugin-api';
import { signOutHooksApiRef } from '@platform/plugin-platform-react';

/**
 * Élément racine : à la déconnexion de l'IDP, oublie aussi le compte GitLab
 * lié (jeton OAuth du navigateur), pour que la personne suivante sur ce
 * navigateur ne retrouve pas ses merge requests.
 *
 * Les deux APIs sont lues de façon optionnelle : un élément racine qui lève
 * finit dans l'errorApi, et la déconnexion n'a pas à en dépendre.
 */
export const GitlabSessionSignOut = () => {
  const holder = useApiHolder();
  const hooks = holder.get(signOutHooksApiRef);
  const gitlabAuth = holder.get(gitlabAuthApiRef);

  useEffect(() => {
    if (!hooks || !gitlabAuth) return undefined;
    return hooks.register(async () => {
      await gitlabAuth.signOut();
    });
  }, [hooks, gitlabAuth]);

  return null;
};
